import { Tooltip } from '../../../../components/Tooltip/Tooltip'
import {
  currencyFormatter,
  sumPercentage
} from '../../../ContractDetails/ContractDetailsGeneral/ContractDetailsForm/utils'
import Typography from '../../../../components/Typography/Typography'
import { TLinearChart } from '../../../../pages/Compliance/types'
type TProps = {
  item: TLinearChart
}
const Chart = ({ item }: TProps) => {
  const { compliant, non_compliant } = item
  return (
    <div
      className="line-chart-compliance row space-between full-width align-center gap-24"
      data-testid="lineChartRow"
    >
      {!!item?.name && (
        <Typography.Caption className="line-chart-compliance__title full-width">
          {item.name}
        </Typography.Caption>
      )}
      {!!item?.category && (
        <Typography.Caption className="line-chart-compliance__title full-width">
          {item.category}
        </Typography.Caption>
      )}
      <div className="table__chart">
        <Tooltip
          className="chart-tooltip-compliance"
          title={
            <div>
              Compliant spend: ${currencyFormatter(compliant || 0)} (
              {sumPercentage(compliant, non_compliant)}%)
              <br />
              Non-compliant spend: ${currencyFormatter(non_compliant || 0)}(
              {sumPercentage(non_compliant, compliant)}%)
            </div>
          }
          placement="topLeft"
        >
          <div
            style={{
              backgroundColor: '#5B8FCE',
              height: '16px',
              width: `${(344 * +compliant) / (+compliant + +non_compliant)}px`
            }}
          />
        </Tooltip>
        <Tooltip
          className="chart-tooltip-compliance"
          title={
            <div>
              Compliant spend: ${currencyFormatter(compliant || 0)} (
              {sumPercentage(compliant, non_compliant)}%)
              <br />
              Non-compliant spend: ${currencyFormatter(non_compliant || 0)}(
              {sumPercentage(non_compliant, compliant)}%)
            </div>
          }
          placement="topLeft"
        >
          <div
            style={{
              backgroundColor: '#F99',
              height: '16px',
              width: `${
                (344 * +non_compliant) / (+compliant + +non_compliant)
              }px`
            }}
          />
        </Tooltip>
      </div>
    </div>
  )
}

export default Chart
